import React, { Component } from "react";
import { Form, Button } from "react-bootstrap";
import $ from "jquery";
import * as utils from "../../../utils.js";

export default class FormFormacionReligiosa extends Component {
  constructor(props) {
    super(props);

    this.FormacionReligiosaPost = this.FormacionReligiosaPost.bind(this);
    this.FormacionReligiosaPut = this.FormacionReligiosaPut.bind(this);
    this.getDefaultValue = this.getDefaultValue.bind(this);
  }

  // Post para formacion religiosa
  FormacionReligiosaPost(event) {
    event.preventDefault();
    let $this = $(this);
    let myform = document.getElementById("MyForm");
    let form = new FormData(myform);

    let settings = {
      url: process.env.REACT_APP_API_URL + "/hermanas/" + $this[0].props.DatosMonja.sister.id + "/estudiosReligiosos",
      method: "POST",
      timeout: 0,
      xhrFields: {
        withCredentials: true,
      },
      processData: false,
      mimeType: "multipart/form-data",
      contentType: false,
      data: form,
    };

    // En caso de exito se edita el estado del componente hermana detalle
    $.ajax(settings)
      .done(function (response) {
        $this[0].props.setAlert("", "Se ha añadido la formación religiosa correctamente", "success");
        response = JSON.parse(response);
        $this[0].props.setFormacionReligiosa(response);
      })
      .fail($this[0].props.ErrorHandling);
  }

  // Igual que el post
  FormacionReligiosaPut(event) {
    event.preventDefault();
    let $this = $(this);
    let myform = document.getElementById("MyForm");
    let form = new FormData(myform);

    let settings = {
      url: process.env.REACT_APP_API_URL + "/hermanas/" + $this[0].props.DatosMonja.sister.id + "/estudiosReligiosos/" + $this[0].props.DatosMonja.datosFormacionReligiosa[this.props.id].id,
      method: "PUT",
      timeout: 0,
      xhrFields: {
        withCredentials: true,
      },
      processData: false,
      mimeType: "multipart/form-data",
      contentType: false,
      data: form,
    };

    $.ajax(settings)
      .done(function (response) {
        $this[0].props.setAlert("", "Se ha editado la formación religiosa correctamente", "success");
        response = JSON.parse(response);
        $this[0].props.putFormacionReligiosa(response, $this[0].props.id);
      })
      .fail($this[0].props.ErrorHandling);
  }

  // Comprueba si estamos editando o añadiendo en caso de estar editando cargamos el valor que habia antes en
  // el field en caso contrario no cargamos ningún valor
  getDefaultValue(field) {
    let defaultvalue;
    if (this.props.id !== undefined) {
      defaultvalue = this.props.DatosMonja.datosFormacionReligiosa[this.props.id][field];
    }
    return defaultvalue;
  }

  render() {
    // Para obtener la fecha actual para la restriccion html
    let today = utils.calculateDate();

    // Si estamos editando no se muestra el tipo de formación
    let tipo_formacion_form =
      this.props.id === undefined ? (
        <Form.Group>
          <Form.Label>Tipo de estudios *</Form.Label>
          <Form.Control required autoComplete="nope" as="select" name="religiousStudies" defaultValue={this.getDefaultValue("religiousStudies")}>
            <option>Preparación de votos</option>
            <option>TER</option>
            <option>CIT TABOR</option>
            <option>CIT SIQUEM</option>
            <option>CIT TIBERIADES</option>
          </Form.Control>
        </Form.Group>
      ) : null;

    return (
      <React.Fragment>
        <Form
          className=" p-4"
          autoComplete="off"
          id="MyForm"
          // Comprobación para saber si estamos editando o añadiendo
          onSubmit={this.props.id !== undefined ? this.FormacionReligiosaPut : this.FormacionReligiosaPost}
        >
          <Form.Group>
            <Form.Row>
              <small className="mb-3">
                Los campos con un <b>*</b> deben de ser rellenados.
              </small>
            </Form.Row>
          </Form.Group>
          {tipo_formacion_form}
          <Form.Group>
            <Form.Label>Año *</Form.Label>
            <Form.Control required autoComplete="nope" type="date" name="religiousStudiesYear" max={today} defaultValue={this.getDefaultValue("religiousStudiesYear")} />
          </Form.Group>
          <Form.Group>
            <Form.Label>Lugar *</Form.Label>
            <Form.Control required max="100" autoComplete="nope" type="text" name="religiousStudiesPlace" defaultValue={this.getDefaultValue("religiousStudiesPlace")} />
          </Form.Group>
          <Form.Group>
            <Button type="submit" variant="outline-dark" className="btn btn-block mt-5" name="Cerrar">
              Guardar
            </Button>
          </Form.Group>
        </Form>
      </React.Fragment>
    );
  }
}
